import {
  RastreioCancerInput,
  RastreioCancerPerguntaDbEnum,
  RastreioCancerPerguntaOpcaoEnum,
  ReferenceMonth,
} from 'graphql/types.generated'
import { formatDate, formatReferenceMonthAsDdMmYyyy } from 'util/date/formatDate'

import { RASTREIO_CANCER_OPCAO_LABEL } from '../model-rastreioCancer'
import { CitopatologicoPerguntaField, RequisicaoExameCitopatologicoFormValues } from './model-citopatologico'
import { convertDataPreventivoMonthYearToDataPreventivoLocalDate } from './utils-citopatologico'

export const convertCitoFormToRastreioCancer = (
  values: RequisicaoExameCitopatologicoFormValues
): RastreioCancerInput[] => {
  const { checkDum, ...perguntaValues } = values
  return Object.entries(perguntaValues)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(
      ([perguntaKey, value]): RastreioCancerInput => {
        const pergunta = perguntaKey as typeof CitopatologicoPerguntaField[keyof typeof CitopatologicoPerguntaField]
        if (pergunta === CitopatologicoPerguntaField.dataPreventivo) {
          const dataPreventivo = (value as unknown) as ReferenceMonth
          return { pergunta, data: convertDataPreventivoMonthYearToDataPreventivoLocalDate(dataPreventivo) }
        } else if (
          pergunta === CitopatologicoPerguntaField.dum ||
          pergunta === CitopatologicoPerguntaField.dataDaColeta
        ) {
          return { pergunta, data: value }
        } else if (
          pergunta === CitopatologicoPerguntaField.nomeResponsavel ||
          pergunta === CitopatologicoPerguntaField.cns ||
          pergunta === CitopatologicoPerguntaField.numeroConselho ||
          pergunta === CitopatologicoPerguntaField.siglaNomeConselho
        ) {
          return { pergunta, descricao: value }
        } else {
          return { pergunta, opcao: value as RastreioCancerPerguntaOpcaoEnum }
        }
      }
    )
}

export function convertRequisicaoExameCitopatologicoFormToMap(
  values: RequisicaoExameCitopatologicoFormValues
): Map<RastreioCancerPerguntaDbEnum, string> {
  const { checkDum, ...perguntaValues } = values

  return new Map(
    Object.entries(perguntaValues)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([perguntaKey, value]) => {
        const pergunta = perguntaKey as typeof CitopatologicoPerguntaField[keyof typeof CitopatologicoPerguntaField]

        if (pergunta === CitopatologicoPerguntaField.dataPreventivo) {
          const dataPreventivo = (value as unknown) as ReferenceMonth
          return [pergunta, formatReferenceMonthAsDdMmYyyy(dataPreventivo) as LocalDate]
        } else if (
          pergunta === CitopatologicoPerguntaField.dum ||
          pergunta === CitopatologicoPerguntaField.dataDaColeta
        ) {
          return [pergunta, formatDate(value)]
        } else if (
          pergunta === CitopatologicoPerguntaField.nomeResponsavel ||
          pergunta === CitopatologicoPerguntaField.cns ||
          pergunta === CitopatologicoPerguntaField.numeroConselho ||
          pergunta === CitopatologicoPerguntaField.siglaNomeConselho
        ) {
          return [pergunta, value]
        } else {
          return [pergunta, RASTREIO_CANCER_OPCAO_LABEL[value as RastreioCancerPerguntaOpcaoEnum]]
        }
      })
  )
}
